export {getIhSourceOpts} from 'utils/ihSources';

export const defaultOrganizationId = 1;

export const appointmentsHourRange = [8, 20];

export const defaultFreeAppointmentsHourRange = [10, 18];

export const clientDeleteReasons = [
	{value: 'underage', label: 'Minor'},
	{value: 'overage', label: 'Too old'},
	{value: 'wrongContactInfo', label: 'Invalid contact info'},
	{value: 'noAuthority', label: 'Does not decide about house matters'},
	{value: 'requestedDelete', label: 'Requested data to be deleted'},
	{value: 'deceased', label: 'Deceased'},
];
